export const EXCMSLA_SHOW_RESET = 'EXCMSLA_SHOW_RESET'
export const EXCMSLA_SHOW_SET_ERROR = 'EXCMSLA_SHOW_SET_ERROR'
export const EXCMSLA_SHOW_SET_RETRIEVED = 'EXCMSLA_SHOW_SET_RETRIEVED'
export const EXCMSLA_SHOW_TOGGLE_LOADING = 'EXCMSLA_SHOW_TOGGLE_LOADING'
